import type { FaireProductEntity } from "../../entity_types/product";

export const p_j7zyaxwzjz: FaireProductEntity = {
  token: "p_j7zyaxwzjz",
  type: "product",
  name: "Thank You Cheetah Die-cut Letterpress Greeting Card by Egg Press",
  brandToken: "b_5m0iqm5t",
  brandName: "Egg Press Manufacturing",
  imageUrl:
    "https://cdn.faire.com/fastly/24ce631dd3bf8d573656b78f6759f157b5c8cb19a1c21b49f5d712c150105bc9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/034472909b798c72e1be8aade59668c55117ba0a2d3dd9ccbf8e4e5e77d14120.jpeg",
    "https://cdn.faire.com/fastly/056fe62a1a8e08f40cb63395897db7624372448be52f9543fdfeb6555e956ba8.jpeg",
  ],
  priceDollars: 3.35,
  description:
    "Rooooaaar, Big thanks! The cheetah's mouth is die-cut to reveal the message printed inside.\n\nWe're EP.MFG, and we make nice cards. ☺ Letterpress printed by hand in Portland, Oregon. Shop cards from five incredible designers, all in one place.\n\n𝗔𝗹𝗹 𝗮𝗯𝗼𝘂𝘁 𝘁𝗵𝗶𝘀 𝗰𝗮𝗿𝗱:\n• Comes with a kraft envelope.\n• This card is available in a plastic sleeve only.\n• Dimensions: A2 (4.25 x 5.5 inches).\n• Designed by EGG PRESS in Portland, OR. Thoughtful as hell since 1999.",
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:33.018Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
